import { DatePicker, DatePickerProps, Form, FormItemProps } from 'antd';
import { useCallback, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { REVERSE_DATE_FORMAT } from 'constants-module';

interface Props extends DatePickerProps {
  readonly minDate?: any;
  readonly maxDate?: any;
  readonly value?: any;
  readonly onChange?: (value: any) => void;
  readonly label?: string;
  readonly errorMessage?: string;
  readonly formItemProps?: FormItemProps;
}

export const AntDatePicker = ({
  id,
  label,
  minDate,
  maxDate,
  value,
  errorMessage,
  formItemProps,
  disabled,
  onChange,
  ...props
}: Props) => {
  const disabledDate: DatePickerProps['disabledDate'] = (current: Dayjs) => {
    const tooLate = current > maxDate;
    const tooEarly = current < minDate;

    return tooEarly || tooLate;
  };

  // AntDatePicker value type is Dayjs.
  // Transform "default value" to string to pass validation.
  useEffect(() => {
    onChange?.(dayjs(value).format(REVERSE_DATE_FORMAT));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = useCallback(
    (date: dayjs.Dayjs) => {
      onChange?.(date?.format(REVERSE_DATE_FORMAT));
    },
    [onChange],
  );

  return (
    <Form.Item
      label={label}
      {...formItemProps}
      htmlFor={id}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : undefined}
    >
      <DatePicker
        {...props}
        id={id}
        allowClear={false}
        style={{ width: '100%' }}
        onChange={handleChange}
        disabled={disabled}
        disabledDate={disabledDate}
        format="DD.MM.YYYY"
        value={dayjs(dayjs(value).format('DD.MM.YYYY'))}
      />
    </Form.Item>
  );
};
